module.exports = __webpack_public_path__ + "static/media/btn-arrow-darkBlue-o.8803f329.svg";